export default "__VITE_ASSET__D4nywJ5E__"